export const API_PATH_ApiAlertMgtmAlertConfigPut = '/services/alerts-mgtm/apiAlertMgtmAlertConfigPut';
